import { render, staticRenderFns } from "./CarwashStore.vue?vue&type=template&id=21c8baf3&"
import script from "./CarwashStore.vue?vue&type=script&lang=js&"
export * from "./CarwashStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports